export const BSB_REGEX = /^\d{0,3}(?:\-)?(?:\s)?\d{0,3}$/gm;
export const BSB_SPEC_CHARS = /[^a-zA-Z0-9-]/gm;
